import React from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import { appRoutes } from '../../path';
import DataModelerPage from './DataModelerPage';
import SidebarLayout from '../../Layout/SidebarLayout';
import DataModelerNav from './DataModelerNav';

const dataModelerRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute allRequiredPermissionKeys={[PermissionKey.DataModelView]}>
        <SidebarLayout>
          <DataModelerNav />
        </SidebarLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        path: appRoutes.modeler.routePrefix + '/:schemaId?',
        element: <DataModelerPage />,
      },
    ],
  },
];

export default dataModelerRoutes;
